import { siteConfig } from '@/config/site';
import { useLanguage } from '@/context/LanguageContext';

export function HowItWorksSection() {
  const { language } = useLanguage();
  const content = siteConfig.content[language].howItWorks;

  return (
    <section id="experience" className="py-20 px-4 sm:px-6 lg:px-8" data-testid="how-it-works-section">
      <div className="max-w-5xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#27D7FF] text-sm font-semibold uppercase tracking-widest mb-2">
            {content.subtitle}
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-[#F4F2FF]">
            {content.title}
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {content.steps.map((step, idx) => (
            <div key={idx} className="relative" data-testid={`step-${idx + 1}`}>
              {/* Connector Line */}
              {idx < content.steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-1/2 w-full h-0.5 bg-gradient-to-r from-[#FF4DA6] to-[#8B5CFF] opacity-30" />
              )}
              
              {/* Step Card */}
              <div className="neon-card text-center relative z-10">
                {/* Step Number */}
                <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#FF4DA6]/20 to-[#8B5CFF]/20 border border-[#FF4DA6]/30 flex items-center justify-center mx-auto mb-6">
                  <span className="text-3xl font-bold text-gradient-pink font-heading">
                    {step.step}
                  </span>
                </div>

                {/* Title */}
                <h3 className="font-heading text-xl font-semibold text-[#F4F2FF] mb-3">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-[#A7A3BA] text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorksSection;
